/**
 * Resolution section data matched to prototype categories.
 */

import {
  RESOLUTION_KINDS,
  kindFromSubtitle,
  resolveResolutionKind,
} from '../utils/resolutionKinds';

export const RESOLUTION_SECTIONS = [
  {
    id: 'directors_kmp',
    title: 'Directors & Key Managerial Personnel',
    items: [
      { id: 'appt_additional_dir', icon: '👤', title: 'Appointment of Additional Director', subtitle: 'u/s 161(1) · DIR-12 within 30 days' },
      { id: 'appt_independent_dir', icon: '🧑‍⚖️', title: 'Independent Director Appointment', subtitle: 'u/s 149(6) · Special Res · MGT-14' },
      { id: 'appt_md', icon: '🏅', title: 'Appointment of MD / WTD', subtitle: 'u/s 196 · Special Res · MR-1' },
      { id: 'appt_cs', icon: '📋', title: 'Company Secretary Appointment', subtitle: 'u/s 203 · DIR-12 within 30 days' },
      { id: 'removal_director', icon: '🚫', title: 'Removal of Director', subtitle: 'u/s 169 · Ordinary Resolution · Special Notice' },
      { id: 'resign_director', icon: '🚪', title: 'Acceptance of Director Resignation', subtitle: 'u/s 168 · DIR-11 & DIR-12' },
      { id: 'reappt_director', icon: '🔄', title: 'Re-appointment of Retiring Director', subtitle: 'u/s 152(6) · AGM rotation' },
      { id: 'increase_remu', icon: '💰', title: 'Increase in Director Remuneration', subtitle: 'u/s 197 · NRC · MGT-14' },
      { id: 'sitting_fees', icon: '💵', title: 'Fixation of Sitting Fees', subtitle: 'u/s 197(5) · Board Resolution' },
      { id: 'loan_director', icon: '🏦', title: 'Loan to Director / Related Party', subtitle: 'u/s 185 · Special Res · MGT-14' },
    ],
  },
  {
    id: 'share_capital',
    title: 'Share Capital & Securities',
    items: [
      { id: 'increase_auth_cap', icon: '⬆️', title: 'Increase in Authorised Capital', subtitle: 'u/s 61 · Ordinary Res · SH-7' },
      { id: 'rights_issue', icon: '📮', title: 'Rights Issue of Shares', subtitle: 'u/s 62(1)(a) · PAS-3 within 30 days' },
      { id: 'private_placement', icon: '🔒', title: 'Private Placement of Shares', subtitle: 'u/s 42 · Special Res · PAS-3, PAS-4' },
      { id: 'bonus_shares', icon: '🎁', title: 'Issue of Bonus Shares', subtitle: 'u/s 63 · Special Res · PAS-3' },
      { id: 'buyback', icon: '🔙', title: 'Buy-Back of Shares', subtitle: 'u/s 68 · Special Res · SH-8, SH-9' },
      { id: 'share_transfer', icon: '🔄', title: 'Share Transfer Approval', subtitle: 'u/s 56 · SH-4 · Register of Members' },
      { id: 'share_transmission', icon: '📑', title: 'Transmission of Shares', subtitle: 'u/s 56(2) · Death / Succession' },
      { id: 'sweat_equity', icon: '🏋️', title: 'Sweat Equity Shares', subtitle: 'u/s 54 · Special Res · SH-8' },
      { id: 'esop', icon: '🎯', title: 'ESOP Scheme Approval', subtitle: 'u/s 62(1)(b) · Special Res · MGT-14' },
      { id: 'forfeiture', icon: '❌', title: 'Forfeiture of Shares', subtitle: 'As per Articles · Board Resolution' },
    ],
  },
  {
    id: 'banking_finance',
    title: 'Banking, Borrowing & Finance',
    items: [
      { id: 'bank_account_open', icon: '🏦', title: 'Open / Change Bank Account', subtitle: 'Board Resolution · Signatories' },
      { id: 'change_signatories', icon: '✍️', title: 'Change of Bank Signatories', subtitle: 'Board Resolution · Bank Intimation' },
      { id: 'od_facility', icon: '💳', title: 'OD / CC Facility Approval', subtitle: 'u/s 179(3)(d) · Avail credit facility' },
      { id: 'term_loan', icon: '📋', title: 'Term Loan Sanction', subtitle: 'u/s 179(3)(d) · Mortgage / Charge' },
      { id: 'intercorporate_loan', icon: '🔗', title: 'Inter-Corporate Loan / Investment', subtitle: 'u/s 186 · Special Res if >limit · MGT-14' },
      { id: 'creation_charge', icon: '🔐', title: 'Creation of Charge / Mortgage', subtitle: 'u/s 77 · CHG-1 within 30 days' },
      { id: 'satisfaction_charge', icon: '✅', title: 'Satisfaction / Release of Charge', subtitle: 'u/s 82 · CHG-4 within 30 days' },
      { id: 'corporate_guarantee', icon: '🛡️', title: 'Providing Corporate Guarantee', subtitle: 'u/s 186 · Special Res · MGT-14' },
    ],
  },
  {
    id: 'restructuring',
    title: 'Corporate Changes & Restructuring',
    items: [
      { id: 'change_name', icon: '📛', title: 'Change of Company Name', subtitle: 'u/s 13 · Special Res · INC-24, INC-25' },
      { id: 'change_office_city', icon: '📍', title: 'Change Registered Office (City)', subtitle: 'u/s 12(5) · INC-22 within 30 days' },
      { id: 'change_office_state', icon: '🗺️', title: 'Change Registered Office (State)', subtitle: 'u/s 13 · Special Res · INC-23 · CLB' },
      { id: 'moa_alteration', icon: '📄', title: 'MOA — Object Clause Alteration', subtitle: 'u/s 13 · Special Res · MGT-14' },
      { id: 'aoa_alteration', icon: '📋', title: 'AOA Alteration', subtitle: 'u/s 14 · Special Res · MGT-14' },
      { id: 'merger', icon: '🤝', title: 'Merger / Amalgamation Approval', subtitle: 'u/s 230-232 · Special Res · NCLT' },
      { id: 'demerger', icon: '✂️', title: 'Demerger / Spin-off', subtitle: 'u/s 230-232 · Special Res · NCLT' },
      { id: 'winding_up', icon: '🔚', title: 'Voluntary Winding Up / Strike Off', subtitle: 'IBC 2016 / STK-2 Application' },
    ],
  },
  {
    id: 'affidavits_bonds',
    title: 'Affidavits, Bonds & Declarations',
    items: [
      { id: 'affidavit_strikeoff', icon: '📜', title: 'Affidavit for Strike Off (STK-2)', subtitle: 'u/s 248 · Required for STK-2 Application' },
      { id: 'affidavit_no_dues', icon: '📜', title: 'Affidavit of No Dues / No Liabilities', subtitle: 'STK-2 · All directors to sign' },
      { id: 'affidavit_no_litigation', icon: '📜', title: 'Affidavit of No Pending Litigation', subtitle: 'STK-2 · Winding Up' },
      { id: 'indemnity_bond_strikeoff', icon: '📋', title: 'Indemnity Bond for Strike Off', subtitle: 'STK-2 Annexure · Notarised' },
      { id: 'affidavit_dormant', icon: '📜', title: 'Affidavit for Dormant Company', subtitle: 'u/s 455 · MSC-1 Application' },
      { id: 'affidavit_name_change', icon: '📜', title: 'Affidavit for Change of Name', subtitle: 'u/s 13 · INC-24' },
      { id: 'declaration_kmp', icon: '📋', title: 'KMP Non-Disqualification Declaration', subtitle: 'u/s 164 · DIR-8 · Board Meeting' },
      { id: 'affidavit_inet', icon: '📜', title: 'Affidavit — Not Liable to IT Returns', subtitle: 'STK-2 · Income Tax Department' },
    ],
  },
  {
    id: 'accounts_audit_dividend',
    title: 'Accounts, Audit & Dividend',
    items: [
      { id: 'adopt_accounts', icon: '📑', title: 'Adoption of Financial Statements', subtitle: 'u/s 129 · Ordinary Res · AOC-4' },
      { id: 'appt_first_auditor', icon: '🔍', title: 'First Auditor Appointment', subtitle: 'u/s 139(6) · Board Res · ADT-1' },
      { id: 'appt_sub_auditor', icon: '🔄', title: 'Subsequent Auditor Appointment', subtitle: 'u/s 139(1) · Ordinary Res · ADT-1' },
      { id: 'removal_auditor', icon: '🚫', title: 'Removal of Auditor', subtitle: 'u/s 140 · CG Approval · ADT-2' },
      { id: 'secretarial_auditor', icon: '📋', title: 'Secretarial Auditor Appointment', subtitle: 'u/s 204 · MR-3 Report' },
      { id: 'interim_dividend', icon: '💵', title: 'Interim Dividend Declaration', subtitle: 'u/s 123 · Board Resolution' },
      { id: 'final_dividend', icon: '💰', title: 'Final Dividend Declaration', subtitle: 'u/s 123 · Ordinary Resolution · AGM' },
      { id: 'iepf_transfer', icon: '🏛️', title: 'IEPF Transfer — Unclaimed Dividend', subtitle: 'u/s 125 · IEPF-1 within 30 days' },
    ],
  },
  {
    id: 'meetings_governance',
    title: 'Meetings, CSR & Governance',
    items: [
      { id: 'fix_agm', icon: '📅', title: 'Fix Date of AGM', subtitle: 'u/s 96 · 21 days clear notice' },
      { id: 'convene_egm', icon: '⚡', title: 'Convene EGM', subtitle: 'u/s 100 · 21 days notice' },
      { id: 'postal_ballot', icon: '📬', title: 'Postal Ballot Resolution', subtitle: 'u/s 110 · MGT-14 within 30 days' },
      { id: 'committee_formation', icon: '👥', title: 'Formation of Board Committee', subtitle: 'Audit / NRC / CSR / Stakeholders' },
      { id: 'csr_policy', icon: '🌱', title: 'CSR Policy & Committee', subtitle: 'u/s 135 · 2% Net Profit · CSR-1' },
      { id: 'rpt', icon: '🔗', title: 'Related Party Transaction', subtitle: 'u/s 188 · Ordinary/Special Res · MGT-14' },
      { id: 'power_of_attorney', icon: '⚖️', title: 'Grant of Power of Attorney', subtitle: 'Board Resolution · Notarised PoA' },
      { id: 'property_purchase', icon: '🏠', title: 'Property Purchase / Sale', subtitle: 'u/s 179(3)(e) · Board Resolution' },
    ],
  },
];

export const RESOLUTIONS = RESOLUTION_SECTIONS.flatMap((section) =>
  section.items.map((item) => ({
    ...item,
    sectionId: section.id,
    sectionTitle: section.title,
  }))
);

export const RESOLUTION_CATEGORIES = RESOLUTION_SECTIONS.map((section) => ({
  id: section.id,
  label: section.title,
}));

/* ── Resolution class (board / ordinary / special) ───────────────────────── */

/**
 * The card subtitles above carry the statutory class ("u/s 196 · Special Res ·
 * MR-1"), so the class is PARSED from them rather than duplicated into a second
 * field that would drift. An explicit `kind` on an item always wins.
 *
 * The parsed values live in src/new-ui/utils/resolutionKinds.js — a byte-identical
 * mirror of backend/new-ui-generation/shared/resolutionKinds.js, because the CHAT
 * draft path runs server-side and cannot import this catalog. That module is the
 * single id→kind ground truth for both paths; this file just re-exports the
 * frontend view of it so existing callers (ResolutionModal) are unchanged.
 *
 * The class is a HARD CONSTRAINT on the AI draft: a matter that needs a
 * members' special resolution must not come back as a plain board resolution
 * (see backend/new-ui-generation/resolution-drafts/promptBuilder.js and the
 * validation gate in resolutionDraftService.js).
 */
export { RESOLUTION_KINDS };

/**
 * The statutory class a resolution must be drafted as.
 * @param {object} item  { id, subtitle, kind? } — a catalog item, or any object
 *                       carrying at least an id (History rows, chat handoffs).
 * @returns {'board'|'ordinary'|'special'}
 */
export function getResolutionKind(item = {}) {
  return resolveResolutionKind(item);
}

/**
 * Every catalog id whose subtitle fixes a class, re-derived from the live cards.
 * The shared mirror's RESOLUTION_KIND_BY_ID must equal this — asserted by
 * backend/new-ui-generation/shared/__tests__/resolutionKindsParity.test.js, so a
 * subtitle edit that changes a class can't silently leave the backend behind.
 */
export const CATALOG_KIND_BY_ID = RESOLUTIONS.reduce((map, item) => {
  const kind = kindFromSubtitle(item.subtitle);
  if (kind) map[item.id] = kind;
  return map;
}, {});
